import {useEffect, useMemo} from 'react';

import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import {Routes} from '../_api/Api';
import DomUtil from '../_util/DomUtil';
import Toast from '../_util/Toast';

import SescLogoImg from '../../img/logo-sesc.png';
import LogoAmico from '../../img/login-amico.png';
import useLoading from "../_lib/hooks/useLoading";
import InputMask from "react-input-mask";


export default function PageLogin() {
    const routes = useMemo(() => new Routes(), []);
    const [loading, startLoading] = useLoading();

    useEffect(() => {
        const {search, pathname} = window.location;
        if (search.endsWith('logout'))
            Toast.success('Você saiu da sua <a>Conta Sesc</a>');
        if (search.endsWith('error'))
            Toast.error('Usuario ou senha inválido.');
        window.history.replaceState({}, document.title, pathname);
    }, []);

    return <div className="container py-5 h-100">
            <div className="row d-flex align-items-center justify-content-center h-100">
                <div className="col-md-8 col-lg-7 col-xl-6">
                    <img src={routes.img(LogoAmico)} className='img-fluid' alt="Sesc Login - Espaço Digital"/>
                </div>
                <div className="col-md-7 col-lg-5 col-xl-5 offset-xl-1">
                        <Form className='bg-light p-3 rounded border shadow-sm' onSubmit={() => startLoading()}  action={DomUtil.getMeta('root') + '/conta/login?_csrf=' + DomUtil.getMeta('_csrf')} method="post">
                            <div className="d-flex flex-row align-items-center justify-content-center justify-content-lg-start mt-3 mb-3">
                                <p className="lead fw-normal mb-0 me-3 text-center text-black">Entrar na Conta Sesc</p>
                            </div>

                            <div className="form-outline mb-4">
                                <Form.Label htmlFor="username" className={'form-label'}>CPF</Form.Label>
                                <Form.Control
                                    as={InputMask}
                                    mask="99999999999"
                                    maskChar=""
                                    alwaysShowMask={false}
                                    required id="username"
                                    name="username"
                                    className="form-control form-control-lg" readOnly={loading} placeholder='CPF'/>
                                <Form.Text className="text-muted">Apenas números</Form.Text>
                            </div>

                            <div className="form-outline mb-3">
                                <Form.Label htmlFor="senha" className="form-label">Senha</Form.Label>
                                <Form.Control className="form-control form-control-lg" type="password" id="senha" name="password"
                                              required={true} readOnly={loading} placeholder={'Senha'} />
                            </div>

                            <div className="d-flex justify-content-between align-items-center">
                                <div className="form-check mb-0"></div>
                                <a className="text-body" href={routes.get('/conta/recuperar')}>
                                    Esqueceu sua senha?
                                </a>
                            </div>

                            <div className="text-center text-lg-start mt-4 pt-2">
                                <Button type="submit" variant="sesc-blue" className="w-100 btn-lg"
                                        disabled={loading}>
                                    {loading ?
                                        <><i className="fa fa-spinner fa-pulse"> </i> Aguarde</> :
                                        <><i className="fa fa-sign-in"> </i> Entrar</>}
                                </Button>
                            </div>

                            <div className="d-flex align-items-center justify-content-center pb-4 mt-4">
                                <p className="mb-0 me-2">Ainda não é cadastrado?</p>
                                <a className="btn btn-outline-warning" href={routes.get('/conta/cadastro')}>
                                    Cadastre-se
                                </a>
                            </div>
                        </Form>
                </div>
            </div>
    </div>;
}